// cfgreftables

const state = {
	cfgreftables: {},
	
};

export default state;